require('intersection-observer');

var ctaTrigger = document.querySelectorAll('.hero');
var ctaBar = document.querySelector('.cta-bar');

if (ctaBar) {
	var observer = new IntersectionObserver(onChange)

	function onChange(entries) {
		for(var i=0; i < entries.length; i++){
			if (entries[i].intersectionRatio > 0) {
				ctaBar.classList.remove('is-visible');
			} else {
				ctaBar.classList.add('is-visible');
			}
		};
	};

	for(var p=0; p < ctaTrigger.length; p++){
		observer.observe(ctaTrigger[p])
	}
};




// WEBPACK FOOTER //
// ./scripts/components/sticky-cta.js